import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { DataGrid, GridToolbar } from '@material-ui/data-grid';

const styles = {
  dataGridRoot: {
    border: 'none',
  },
};

class DataGridVisualizer extends Component {
  render() {
    const { data, classes, options } = this.props;
    const { rows, columns } = data[0];

    return (
      <div style={{ width: '100%' }}>
        <DataGrid
          autoHeight
          disableSelectionOnClick
          disableDensitySelector
          disableColumnMenu
          rows={rows}
          columns={columns}
          pageSize={10}
          getRowId={row => row[columns[0].field]}
          components={{
            Toolbar: GridToolbar,
          }}
          classes={{ root: classes.dataGridRoot }}
          {...options}
        />
      </div>
    );
  }
}

DataGridVisualizer.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  options: PropTypes.object,
};

DataGridVisualizer.defaultProps = {
  options: null,
};

export default withStyles(styles)(DataGridVisualizer);
